import './styles/ExclusiveBenefits.css';
import VerifyIcon from '../assets/imgs/verifyicon.png';

function ExclusiveBenefits() {
    return (
        <div className="ExclusiveBenefits fade-in">
            <h3>Diferenciais exclusivos Biosafe:</h3>
            <div className="exb-cards">
                <div className="card fade-in-up">
                    <img src={VerifyIcon} alt="" className='VerifyIcon' aria-hidden="true"/>
                    <p>Conteúdo embasado em normas e bibliografia técnica;</p>
                </div>
                <div className="card fade-in-up">
                    <img src={VerifyIcon} alt="" className='VerifyIcon' aria-hidden="true"/>
                    <p>Linguagem direta e objetiva sem achismos;</p>
                </div>
                <div className="card fade-in-up">
                    <img src={VerifyIcon} alt="" className='VerifyIcon' aria-hidden="true"/>
                    <p>Exemplos práticos e simulações reais;</p>
                </div>
                <div className="card fade-in-up">
                    <img src={VerifyIcon} alt="" className='VerifyIcon' aria-hidden="true"/>
                    <p>Você terá um ano para assistir quantas vezes quiser!</p>
                </div>
            </div>
        </div>
    )
};

export default ExclusiveBenefits;